module.exports = __webpack_public_path__ + "img/strgCtrl.f3ca87c6.svg";